.uic-table-head-sort {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  transition: all 0.1s;

  &[sorted-direction='asc'] {
    color: var(--uic-color-blue3);
    line-height: var(--uic-line-height-normal);
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: $text-shadow-regular;
    white-space: nowrap;

    .uic-table-head-sort__icon svg:last-child {
      visibility: hidden;
    }
  }

  &[sorted-direction='desc'] {
    color: var(--uic-color-blue3);
    line-height: var(--uic-line-height-normal);
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: $text-shadow-regular;
    white-space: nowrap;

    .uic-table-head-sort__icon svg:first-child {
      visibility: hidden;
    }
  }

  &__icon {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    margin-left: -5px;
    margin-right: 2px;
    order: -1;
    right: 0;
    top: 0;

    svg {
      height: 12px;
      width: 22px;

      &:last-child {
        margin-top: -7px;
      }
    }
  }
}
